export function isEmpty(object) {
    return !object || !Object.keys(object).length;
}
//# sourceMappingURL=is-empty.js.map